<style scoped>
	.checkin_information_single {
		width: 1210px;
		height: 130px;
		background: white;
		box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
		border-radius: 6px 6px 6px 6px;
		padding: 15px 30px 0 30px;
		box-sizing: border-box;
	}

	.checkin_information_single_content {
		display: flex;
		align-items: center;
		margin: 14px 0;
		justify-content: space-between;
	}

	.checkin_information_single_people {
		font-size: 28px;
		color: #313b5e;
		font-weight: bold;
	}

	.checkin_information_single_item {
		text-align: center;
    cursor: pointer;
	}

	.checkin_information_single_icon {
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}

	.checkin_information_btoom {
		display: flex;
		align-items: center;
		margin-top: 10px;
		flex: 1;
		justify-content: space-between;
	}

	.checkin_information_data {
		width: 1213px;
		height: 100%;
		display: flex;
		flex-direction: column;
		background: #ffffff;
		box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
		border-radius: 6px 6px 6px 6px;
	}
</style>

<template>
	<div class="checkin_information_single">
		<div>{{ title }}</div>
		<div class="checkin_information_single_content">
			<div v-if="value && value.length>0" v-for="(item,index) in value" :key="index"
				class="checkin_information_single_item" @click="handleClick(item)">
				<div class="checkin_information_single_people">{{ item.value }}</div>
				<div style="display: inline-flex;align-items:center;margin-top: 5px;">
					<div class="checkin_information_single_icon" :style="{background:item.color}"></div>
					<span style="margin-left: 5px;">{{ item.title }}</span>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		components: {},
		props: {
			title: {
				type: String,
				default: ''
			},
			value: {
				type: [Array],
				default: () => []
			}
		},
		data() {
			return {};
		},
		created() {

		},
		mounted() {

		},
		methods: {
			handleClick(item) {
				let type;
				switch (item.title) {
					case '加班申请':
						type = 1;
						break;
					case '补班申请':
						type = 2;
						break;
					case '请假申请':
						type = 3;
						break;
					case '出差申请':
						type = 4;
						break;
					case '外出申请':
						type = 5;
						break;
					case '人脸申请':
						type = 6;
						break;
				}
				this.$router.replace({
					name: 'eventApproval',
					  params: {
					    type: type
					  }
				})
			}
		}
	};
</script>